export default "__VITE_ASSET__dbec17bd__"